import React from 'react';
import {
    CategoriaOption,
    CentroFormData,
    DetalleOption,
    MarcaOption,
    ModeloOption,
    SubcategoriaOption,
} from '../../types/centro.types';

interface TabServiciosProps {
    formData: CentroFormData;
    categorias: CategoriaOption[];
    subcategorias: SubcategoriaOption[];
    detalles: DetalleOption[];
    marcas: MarcaOption[];
    modelos: ModeloOption[];
    selectedCat: string;
    setSelectedCat: (v: string) => void;
    selectedSub: string;
    setSelectedSub: (v: string) => void;
    selectedDet: string;
    setSelectedDet: (v: string) => void;
    selectedMarca: string;
    setSelectedMarca: (v: string) => void;
    selectedModelo: string;
    setSelectedModelo: (v: string) => void;
    onAddService: (e: React.MouseEvent) => void;
    onRemoveService: (index: number, e: React.MouseEvent) => void;
}

export const TabServicios: React.FC<TabServiciosProps> = ({
    formData,
    categorias,
    subcategorias,
    detalles,
    marcas,
    modelos,
    selectedCat,
    setSelectedCat,
    selectedSub,
    setSelectedSub,
    selectedDet,
    setSelectedDet,
    selectedMarca,
    setSelectedMarca,
    selectedModelo,
    setSelectedModelo,
    onAddService,
    onRemoveService,
}) => (
    <>
        <div className="p-4 rounded border mb-4 shadow-sm">
            <h6 className="fw-bold mb-3">
                <i className="fas fa-filter text-primary me-2" />1. Seleccione el Alcance del Servicio
            </h6>
        <div id="centro-servicios-filtro" className="row g-3 mb-4 border-bottom pb-4">
                <div className="col-md-4">
                    <label className="fw-bold small mb-1">Categoría Principal *</label>
                    <select className="form-select shadow-sm" value={selectedCat} onChange={(e) => setSelectedCat(e.target.value)}>
                        <option value="">-- Obligatorio --</option>
                        {categorias.map((c) => (
                            <option key={c.id ?? c.clave_categoria} value={c.id ?? c.clave_categoria}>
                                {c.nombre ?? c.categoria}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-4">
                    <label className="fw-bold small mb-1">
                        Subcategoría <span className="fw-normal fst-italic">(Opcional)</span>
                    </label>
                    <select
                        className="form-select shadow-sm"
                        value={selectedSub}
                        onChange={(e) => setSelectedSub(e.target.value)}
                        disabled={!selectedCat}
                    >
                        <option value="">Todas las subcategorías</option>
                        {subcategorias.map((s) => (
                            <option key={s.clave_subcategoria} value={s.clave_subcategoria}>
                                {s.subcategoria}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-4">
                    <label className="fw-bold small mb-1">
                        Detalle Específico <span className="fw-normal fst-italic">(Opcional)</span>
                    </label>
                    <select
                        className="form-select shadow-sm"
                        value={selectedDet}
                        onChange={(e) => setSelectedDet(e.target.value)}
                        disabled={!selectedSub}
                    >
                        <option value="">Todos los detalles</option>
                        {detalles.map((d) => (
                            <option key={d.clave_subcategoria_detalle} value={d.clave_subcategoria_detalle}>
                                {d.titulo}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            <h6 className="fw-bold mb-3">
                <i className="fas fa-car text-primary me-2" />2. Seleccione el Alcance del Vehículo
            </h6>
            <div id="centro-servicios-vehiculo" className="row g-3">
                <div className="col-md-4">
                    <label className="fw-bold small mb-1">Marca de Vehículo</label>
                    <select className="form-select shadow-sm" value={selectedMarca} onChange={(e) => setSelectedMarca(e.target.value)}>
                        <option value="ALL">Todas las Marcas</option>
                        {marcas.map((m) => (
                            <option key={m.clave_marca} value={m.clave_marca}>
                                {m.marca}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-4">
                    <label className="fw-bold small mb-1">
                        Modelo de Vehículo <span className="fw-normal fst-italic">(Opcional)</span>
                    </label>
                    <select
                        className="form-select shadow-sm"
                        value={selectedModelo}
                        onChange={(e) => setSelectedModelo(e.target.value)}
                        disabled={selectedMarca === 'ALL'}
                    >
                        <option value="ALL">Todos los Modelos</option>
                        {modelos.map((m) => (
                            <option key={m.clave_modelo} value={m.clave_modelo}>
                                {m.modelo}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-4 d-flex align-items-end">
                    <button
                        id="centro-servicios-agregar"
                        type="button"
                        className="btn btn-primary w-100 fw-bold shadow-sm"
                        onClick={onAddService}
                        disabled={!selectedCat}
                    >
                        <i className="fas fa-plus me-2" /> Agregar Regla de Servicio
                    </button>
                </div>
            </div>
        </div>

        <h6 className="fw-bold mb-2">Servicios Configurados ({formData.servicios.length})</h6>
        <div id="centro-servicios-tabla" className="table-responsive border rounded shadow-sm">
            <table className="table table-hover table-sm align-middle mb-0">
                <thead>
                    <tr>
                        <th>Categoría</th>
                        <th>Subcategoría</th>
                        <th>Detalle</th>
                        <th className="border-start">Marca</th>
                        <th>Modelo</th>
                        <th className="text-center" style={{ width: '80px' }}>
                            Quitar
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {formData.servicios.length === 0 ? (
                        <tr>
                            <td colSpan={6} className="text-center py-4 fst-italic">
                                No hay reglas de servicio configuradas para este centro.
                            </td>
                        </tr>
                    ) : (
                        formData.servicios.map((s, idx) => (
                            <tr key={`${s.idCategoria}-${s.idSubcategoria}-${s.idDetalle}-${idx}`}>
                                <td>
                                    <span className="badge bg-primary bg-opacity-10 text-primary">{s.categoria}</span>
                                </td>
                                <td>{s.subcategoria || <span className="fst-italic small">Todas</span>}</td>
                                <td className="fw-bold">
                                    {s.detalle || <span className="fst-italic fw-normal small">Todos</span>}
                                </td>
                                <td className="border-start fw-bold">{s.marca}</td>
                                <td>
                                    {s.modelo === 'Todos los modelos' ? (
                                        <span className="fst-italic small">Todos</span>
                                    ) : (
                                        s.modelo
                                    )}
                                </td>
                                <td className="text-center">
                                    <button
                                        type="button"
                                        className="btn btn-sm text-danger"
                                        onClick={(e) => onRemoveService(idx, e)}
                                        title="Eliminar regla"
                                    >
                                        <i className="fas fa-times-circle fs-5" />
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    </>
);
